module.exports = __webpack_public_path__ + "static/media/multiplex3-0.2243bb2f.png";